import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FacebookLoginProvider, SocialAuthService, SocialUser } from "angularx-social-login";
import { Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'MultiGameLogin';
  public guestName = 'ggg';
  public showEnterNewName = false;
  public fbToken="";
  public lang = 'bg';
  public gID = 23;
  public langUname = 'Потребителско име';
  public langPass = 'Парола';
  public langGuess = 'Логин като гост';
  public langExist = 'Вашето име съществува в нашата система. Моля изберете друго потребителско име';
  public langEnter = 'Вход';
  @ViewChild('loginForm', {static: true}) private loginForm: ElementRef;
  constructor(private authService: SocialAuthService, public http: HttpClient) {
  }

  ngOnInit() {
     
    const win: any = window;
    const success = win.success;
    this.guestName = win.guestNum;
    if(win.lang){
      this.lang = win.lang
      if(win.lang==='en'){
        this.langUname = 'Username';
        this.langPass = 'Password';
        this.langGuess = 'Login as a guest';
        this.langExist = 'This username already exists in our system. Please choose another username';
        this.langEnter = 'Enter';
      }
    }
    if(win.gID){
      this.gID = win.gID;
    }
    if(success !== 'uExist'){
      this.authService.authState.subscribe((user) => {
        this.fbToken = user.authToken;
        
          setTimeout(()=>{
            this.loginForm.nativeElement.submit(); 
          },50);
        }
      );  
    }else{
      this.showEnterNewName = true;
      this.fbToken = win.token;
    }
    
    
     
  }

   

  public signInWithFB(): void {
    this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
  }
}
